export default {
  black: 'RGBA(30, 30, 30, 1.00)',
  claro: '#F0F4F3',
  oscuro: '#35404C',
  medio: 'RGBA(223, 223, 223, 1.00)',
  main: '#1B94AD'
};



// WEBPACK FOOTER //
// ./src/utils/colors.js